<script lang="ts">
  /*
   * The chrome for the three signed-out pages.
   *
   * SAME APP BAR AS EVERYWHERE ELSE, which is the point rather than a detail: sign-in is where somebody
   * arriving from `support.` or `www.` most often lands, and a page with no bar — or with a different
   * one — is exactly the seam that makes the estate feel like separate products. The bar previously had
   * a bespoke centred wordmark here; it now has the real thing.
   *
   * No account navigation, because there is no account yet, and the card is narrow: a form nobody can
   * widen should not be as wide as the reading column.
   */
  import type { Snippet } from 'svelte'
  import AppBar from './AppBar.svelte'

  let { title, children }: { title: string; children: Snippet } = $props()
</script>

<AppBar />

<div class="page">
  <main class="card">
    <h1>{title}</h1>
    {@render children()}
  </main>
</div>

<style>
  .page {
    max-width: 26rem;
    margin: 0 auto;
    padding: var(--space-10) var(--space-5) var(--space-12);
  }
  h1 {
    font-size: 1.35rem;
    margin-bottom: var(--space-5);
  }
</style>
